// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__tuBoF","desktop":"style_desktop__qGQqH","light":"style_light__oDsSW","original":"style_original__SdIAr"};